<template>
  <div id="wrap">
    <app-header />
    <main>
      <h2 class="smttl">
        <span>ただ今有料サービスのお申込み期間外です。</span>
      </h2>
      <p class="ltd mb2">
        大変申し訳ございませんが&#x3000;お申込み開始まで<br />お待ちいただけますようお願いいたします。
      </p>

      <div class="btn">
        <a class="btn home" href="https://tsuitamon.jp/"
          >ツイタもんトップページへ戻る</a
        ><br />
      </div>
    </main>

    <app-footer />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
  </div>
</template>

<script>
import CmnSubMixin from "@mixins/cmnsub-mixin";
import AppHeader from "@components/AppHeader";
import AppFooter from "@components/AppFooter";
import LoadingAnim from "@components/LoadingAnim";

export default {
  name: "OutOfPeriods",
  mixins: [CmnSubMixin],
  components: {
    AppHeader,
    AppFooter,
    LoadingAnim,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
